import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='isInitScreenEnabled' subtitle='Boolean' label='Default: true' mdxType="Item">
      <p>{`Set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` to hide the loading screen before the Universal Checkout or the Vault Manager.`}</p>
    </Item>
    <Item title='isSuccessScreenEnabled' subtitle='Boolean' label='Default: true' mdxType="Item">
      <p>{`Set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` to hide the screen after a successful payment, or tokenization on the vault flow.`}</p>
    </Item>
    <Item title='isErrorScreenEnabled' subtitle='Boolean' label='Default: true' mdxType="Item">
      <p>{`Set to `}<inlineCode parentName="p">{`false`}</inlineCode>{` to hide the error screen when an error occurs.`}</p>
    </Item>
    <Item title='dismissalMechanism' subtitle='DismissalMechanism' label='Default: GESTURES' mdxType="Item">
      <p>{`Set the mechanism for dismissing Universal Checkout. Options are:`}</p>
      <ul>
        <li parentName="ul"><inlineCode parentName="li">{`GESTURES`}</inlineCode>{`: The dialog can be dismissed by tapping outside or by swiping down.`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`CLOSE_BUTTON`}</inlineCode>{`: A close button is provided, allowing users to dismiss the dialog manually.`}</li>
      </ul>
    </Item>
    <Item title='theme' subtitle='PrimerTheme' mdxType="Item">
      <p>{`Set a custom theme for Primer SDK.`}</p>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      